import React from 'react';
import ToolbarButton, { ToolbarButtonGroup } from './ToolbarButton';
import { spanDefaultIcon, spanFullIcon, spanHalfIcon } from '../../editorIcons';

type SpanValue = 'full' | 'half' | null;

interface ToolbarSpanButtonGroupProps {
  allowHalfWidth?: boolean;
  disallowDefaultWidthActive?: boolean;
  span: unknown;
  onSpanChange: (newSpan: SpanValue) => void;
}

const ToolbarSpanButtonGroup = ({
  allowHalfWidth,
  disallowDefaultWidthActive,
  span,
  onSpanChange,
}: ToolbarSpanButtonGroupProps) => (
  <ToolbarButtonGroup aria-label="Width options" role="radiogroup">
    {allowHalfWidth ? (
      <ToolbarButton
        accessibleType="radio"
        icon={spanHalfIcon}
        tooltip="Half width"
        active={span === 'half'}
        onClick={() => onSpanChange('half')}
      />
    ) : null}
    <ToolbarButton
      accessibleType="radio"
      icon={spanDefaultIcon}
      tooltip="Default width"
      active={!span && !disallowDefaultWidthActive}
      onClick={() => onSpanChange(null)}
    />
    <ToolbarButton
      accessibleType="radio"
      icon={spanFullIcon}
      tooltip="Wide width"
      active={span === 'full'}
      onClick={() => onSpanChange('full')}
    />
  </ToolbarButtonGroup>
);

export default ToolbarSpanButtonGroup;
